import { quoteGhlCheckout } from '@/api/ghlPayment.api';

export function applyShippingQuoteResult(state, data) {
  if (!data || !data.success) {
    state.shippingQuoteError.value = (data && data.message) || 'Unable to load delivery options';
    state.requiresShipping.value = false;
    state.shippingMethods.value = [];
    state.selectedShippingMethod.value = '';
    return;
  }

  state.shippingQuoteError.value = '';
  state.requiresShipping.value = Boolean(data.requiresShipping);
  state.shippingMethods.value = Array.isArray(data.shippingMethods) ? data.shippingMethods : [];

  const current = state.selectedShippingMethod.value;
  const stillValid = state.shippingMethods.value.some((method) => method.code === current);
  if (stillValid) return;

  if (state.shippingMethods.value.length === 1) {
    state.selectedShippingMethod.value = state.shippingMethods.value[0].code;
    return;
  }

  state.selectedShippingMethod.value = '';
}

export function selectedShippingCost(state) {
  const match = state.shippingMethods.value.find(
    (method) => method.code === state.selectedShippingMethod.value
  );
  return match ? Number(match.cost || 0) : 0;
}

export function shippingSelectionReady(state) {
  if (!state.requiresShipping.value) return true;
  if (state.quotingShipping.value) return false;
  if (state.shippingQuoteError.value) return false;
  if (!state.shippingMethods.value.length) return false;
  return Boolean(state.selectedShippingMethod.value);
}

export async function fetchShippingQuote(payload, state) {
  state.quotingShipping.value = true;
  state.shippingQuoteError.value = '';

  try {
    const { data } = await quoteGhlCheckout(payload);
    applyShippingQuoteResult(state, data);
  } catch (err) {
    const errResponse = err && err.response;
    const errData = errResponse && errResponse.data;
    applyShippingQuoteResult(state, {
      success: false,
      message: (errData && errData.message) || err.message || 'Unable to load delivery options'
    });
  } finally {
    state.quotingShipping.value = false;
  }
}

export function createShippingQuoteState() {
  return {
    shippingMethods: { value: [] },
    selectedShippingMethod: { value: '' },
    requiresShipping: { value: false },
    quotingShipping: { value: false },
    shippingQuoteError: { value: '' }
  };
}
